import React from 'react';
import { formatLocalizedNumberInputValue, normalizeLocalizedNumberInput } from '../../utils/numberFormat';

function LocalizedNumberInput({
  value,
  onValueChange,
  decimals = 2,
  allowNegative = false,
  // Por defecto se selecciona el contenido al enfocar: estos campos casi
  // siempre vienen con un valor precargado (0, un saldo, una cantidad) y
  // escribir encima sin borrar concatenaba digitos ("03500" en vez de "3500").
  selectOnFocus = true,
  onFocus,
  className = '',
  ...props
}) {
  const displayValue = formatLocalizedNumberInputValue(value, { decimals, allowNegative });

  const handleChange = (event) => {
    const normalized = normalizeLocalizedNumberInput(event.target.value, { decimals, allowNegative });
    onValueChange?.(normalized.display, normalized, event);
  };

  const handleFocus = (event) => {
    if (selectOnFocus) {
      event.target.select();
    }
    onFocus?.(event);
  };

  return (
    <input
      {...props}
      type="text"
      inputMode={decimals === 0 ? 'numeric' : 'decimal'}
      autoComplete="off"
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      className={className}
    />
  );
}

export default LocalizedNumberInput;
